interface EmptyButtonProps {
  title: string;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

const EmptyButton = ({ title, onClick }: EmptyButtonProps) => {
  return (
    <button
      className="flex h-[30px] w-full items-center rounded-[5px] px-1 text-sm font-normal text-placeholder"
      onClick={onClick}
    >
      {title}
    </button>
  );
};

export default EmptyButton;
